export default __webpack_public_path__ + "static/media/sb-final1.7677eed3.png";